namespace RedBullMOBILE360.CVM {
    export class CvmSegmentColumns {
        static columnsKey = 'CVM.CvmSegment';
    }
}